import request from "@/utils/request";

let GoodsApi = {
    /*分类管理*/
    catList(data, errorback) {
        return request._post("/merch/goods.category/index", data, errorback);
    },
    /*分类添加*/
    catAdd(data, errorback) {
        return request._post("/merch/goods.category/add", data, errorback);
    },
    /*分类删除*/
    catDel(data, errorback) {
        return request._post("/merch/goods.category/delete", data, errorback);
    },
    /*分类修改*/
    catEdit(data, errorback) {
        return request._post("/merch/goods.category/edit", data, errorback);
    },
    /*产品列表*/
    goodsList(data, errorback) {
        return request._post("/merch/goods.goods/index", data, errorback);
    },
    /*产品选择列表*/
    chooseLists(data, errorback) {
        return request._post("/merch/data.goods/lists", data, errorback);
    },
    /*规格选择列表*/
    chooseSpec(data, errorback) {
        return request._post("/merch/data.goods/spec", data, errorback);
    },
    /*新增产品*/
    addGoods(data, errorback) {
        return request._post("/merch/goods.goods/add", data, errorback);
    },
    /*产品基础数据*/
    getBaseData(data, errorback) {
        return request._get("/merch/goods.goods/add", data, errorback);
    },
    /*删除产品*/
    delGoods(data, errorback) {
        return request._post("/merch/goods.goods/delete", data, errorback);
    },
    /*产品基础数据*/
    getEditData(data, errorback) {
        return request._get("/merch/goods.goods/edit", data, errorback);
    },
    /*新增产品*/
    editGoods(data, errorback) {
        return request._post("/merch/goods.goods/edit", data, errorback);
    },
    /*新增规格组*/
    addSpec(data, errorback) {
        return request._post("/merch/goods.spec/addSpec", data, errorback);
    },
    /*新增规格值*/
    addSpecValue(data, errorback) {
        return request._post("/merch/goods.spec/addSpecValue", data, errorback);
    },
    /*商品列表不带分页*/
    getList(data, errorback) {
        return request._post("/merch/data.goods/lists", data, errorback);
    },
    /*商品列表不带分页*/
    getActiveGoodsList(data, errorback) {
        return request._post("/merch/plus.fans.goods/lists", data, errorback);
    },
    /*商品评论列表*/
    getCommentList(data, errorback) {
        return request._post("/merch/goods.comment/index", data, errorback);
    },
    /*获取评论详情*/
    getComment(data, errorback) {
        return request._post("/merch/goods.comment/detail", data, errorback);
    },
    /*获取评论详情*/
    editComment(data, errorback) {
        return request._post("/merch/goods.comment/edit", data, errorback);
    },
    /*删除评论*/
    delComment(data, errorback) {
        return request._post("/merch/goods.comment/delete", data, errorback);
    },
    /*得到分类图片*/
    cateImage(data, errorback) {
        return request._post("/merch/goods.category/image", data, errorback);
    },
    /*修改状态*/
    changeStatus(data, errorback) {
        return request._post("/merch/goods.goods/state", data, errorback);
    },
    /*获取随机码*/
    getToken(data, errorback) {
        return request._get("/merch/goods.goods/getToken", data, errorback);
    },
    /*调整顺序*/
    changeSort(data, errorback){
        return request._post("/merch/goods.goods/changeSort", data, errorback);
    },


    /*新增优惠券*/
    getCoupon(data, errorback) {
        return request._get("/merch/goods.coupon/index", data, errorback);
    },
    /*修改优惠券*/
    editCoupon(data, errorback) {
        return request._post("/merch/goods.coupon/edit", data, errorback);
    },
    /*删除优惠券*/
    delCoupon(data, errorback) {
        return request._post("/merch/goods.coupon/delete", data, errorback);
    },

    /*新增关联商品*/
    getRelation(data, errorback) {
        return request._get("/merch/goods.relation/index", data, errorback);
    },
    /*修改关联商品*/
    editRelation(data, errorback) {
        return request._post("/merch/goods.relation/edit", data, errorback);
    },
    /*删除关联商品*/
    delRelation(data, errorback) {
        return request._post("/merch/goods.relation/delete", data, errorback);
    },
};

export default GoodsApi;



// WEBPACK FOOTER //
// ./src/api/goods.js